import React, { createContext, useContext } from 'react';

export const GeneralContext = createContext();

export const GeneralContextProvider = (props) => {
        const year = new Date().getMonth() > 4 ? new Date().getFullYear() : new Date().getFullYear() - 1;

        const generals = {
                ID_OFFSET: 5108,
                YEAR: year
        };

        return (
                <GeneralContext.Provider value={generals}>
                        {props.children}
                </GeneralContext.Provider>
        );
};

export const useGeneralContext = () => useContext(GeneralContext);